import clsx from 'clsx'
import { DocumentDuplicateIcon, PencilIcon, TrashIcon } from '@heroicons/react/24/solid'
import {
    UI_TABLE_ROW_ACTION_BUTTON_BASE_CLASS,
    UI_TABLE_ROW_ACTION_BUTTON_ICON_CLASS,
    UI_TABLE_ROW_ACTION_BUTTON_VARIANT_CLASS,
} from './UiTableSharedStyles'

type UiTableRowActionButtonVariant = 'edit' | 'delete' | 'duplicate'

interface UiTableRowActionButtonProps {
    variant: UiTableRowActionButtonVariant
    title: string
    onClick: () => void
    className?: string
}

const UiTableRowActionButton = (props: UiTableRowActionButtonProps) => {
    const Icon = props.variant === 'edit' ? PencilIcon : props.variant === 'duplicate' ? DocumentDuplicateIcon : TrashIcon

    return (
        <button
            onClick={(event) => {
                event.stopPropagation()
                props.onClick()
            }}
            className={clsx(
                'UiTableRowActionButton',
                UI_TABLE_ROW_ACTION_BUTTON_BASE_CLASS,
                UI_TABLE_ROW_ACTION_BUTTON_VARIANT_CLASS[props.variant],
                props.className
            )}
            title={props.title}
            type={'button'}
        >
            <Icon className={clsx(UI_TABLE_ROW_ACTION_BUTTON_ICON_CLASS)} />
        </button>
    )
}

export default UiTableRowActionButton